import { capitalize } from 'lodash';
import React from 'react';
import { numberWithCommas, titleCase } from '../../../../utils/helpers';
import Image from '../../../common/image';

const MaxCapTable = ({ cards, showExpired }) => {
	return (
		<div className='table-responsive'>
			<table className='table table-sm myTable text-center'>
				<thead>
					<tr>
						<th>Package</th>
						<th>Amount</th>
						<th>Date</th>
						<th>Type</th>
						<th>Status</th>
						<th>Max Cap</th>
						<th>Used Max Cap</th>
					</tr>
				</thead>
				<tbody>
					{cards
						.filter(
							(c) => c.status === 'active' || (c.status === 'expired' && showExpired)
						)
						.map((card, key) => {
							const percentage = Number(
								((card.usedMaxCap * 100) / card.maxCap).toFixed(2)
							);
							return (
								<tr
									className={card.status === 'expired' ? 'expiredCard' : ''}
									key={key}>
									<td>
										<div className='centerAll'>
											<div className='fs-7'>{titleCase(`${card.name}`)}</div>
											<Image
												height='60px'
												fileName={`diamonds/${card.name}.webp`}
												className='ms-2'
											/>
										</div>
									</td>

									<td>{'$' + numberWithCommas(card.amount / 1e6)}</td>
									<td> {new Date(card.date).toLocaleDateString()}</td>
									<td>{card.purchaseType}</td>
									<td>{capitalize(card.status)}</td>
									<td>
										{'$' + numberWithCommas(card.usedMaxCap / 1e6)} /{' '}
										{'$' + numberWithCommas(card.maxCap / 1e6)}{' '}
									</td>
									<td>
										<div>{`${percentage}%`}</div>
										<div className='d-flex justify-content-center align-items-center'>
											<span
												className='progress myProgress'
												title={`${percentage}%`}
												style={{
													width: '80px',
													height: '10px',
												}}>
												<div
													className='progress-bar'
													role='progressbar'
													aria-label='Max Cap'
													style={{
														width: `${percentage}%`,
													}}
													aria-valuenow={Number(percentage)}
													aria-valuemin='0'
													aria-valuemax='100'></div>
											</span>
										</div>
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
		</div>
	);
};

export default MaxCapTable;
